export default __webpack_public_path__ + "static/media/showroom42.76bf0214.jpg";